export function isYoutubeLink(link) {
  if (link === null || link === undefined) {
    return false;
  }
  return link.includes("youtube");
}
